/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react"
import cRequest from "@services/c-request"
import { detectOS } from "@app/helpers"

interface pwaSubscriptionProps {
  uid: string
  subscriptions: (PushSubscription | { endpoint: null; keys: {} })[]
}

function urlBase64ToUint8Array(base64: any) {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4)
  const base64Safe = (base64 + padding).replace(/\-/g, "+").replace(/_/g, "/")
  const raw = atob(base64Safe) //@ts-ignore
  return new Uint8Array([...raw].map((c) => c.charCodeAt(0)))
}

export const usePWASubscription = ({
  uid,
  subscriptions = [],
}: pwaSubscriptionProps) => {
  // check if the user is on iOS/macOS Safari where they need to install pwa first
  const [needsInstall, setNeedsInstall] = useState(false)

  useEffect(() => {
    const isSafari =
      /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      (navigator as any).standalone

    if (isSafari && !isStandalone) {
      setNeedsInstall(true)
    }
  }, [])

  // check the operating system of the user
  const operatingSystem = detectOS(navigator)

  // should ask permission
  const shouldAskPermission = (subscriptions: any[]) => {
    if (
      !subscriptions ||
      !subscriptions.length ||
      !subscriptions[subscriptions.length - 1].endpoint
    ) {
      return true
    }
    return false
  }

  // subscribe user to notifications
  const subscribeUser = async (uid: string, permission: string) => {
    let currentSubscription: any

    if (permission === "granted") {
      const registration = await navigator.serviceWorker.ready
      currentSubscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(
          process.env.REACT_APP_VAPID_PUBLIC_KEY
        ),
      })
    } else {
      currentSubscription = {
        endpoint: null,
        keys: {},
      }
    }

    subscriptions.push(currentSubscription)

    return cRequest
      .post(
        `${process.env.REACT_APP_BASE_URL}/notifications/subscribe-to-pwa`,
        { uid, subscriptions }
      )
      .then(function (response: any) {
        return response.data
      })
      .catch(function (error: any) {
        console.log(error)
        throw error
      })
  }

  const subscribeFn = () => {
    if ("serviceWorker" in navigator && "PushManager" in window) {
      Notification.requestPermission().then((permission) => {
        subscribeUser(uid, permission)
      })
    }
  }

  return { subscribeFn, operatingSystem, shouldAskPermission, needsInstall }
}
